var map = {
	"./0iconmonstr-paintbrush-7.svg": 3195,
	"./1blueBath.png": 3907,
	"./2redBath.png": 173,
	"./3greenBath.png": 830,
	"./4goldBath.png": 2206,
	"./5grayBath.png": 5886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8528;